import { useAppSelector } from '../../redux/hooks';
import EReg from '../e-reg/ereg';
import Pips from '../e-reg/Pips';
import ClientPortal from '../../Components/clientportal/App'
import Registrations from '../Registrations/Registration';
import React from 'react';
import SimilarNames from '../SimilarNames/similarName';
import { BuilderDoc } from '../BuilderConnect/BuilderDoc/BuilderDoc';
import { BuilderEsign } from '../BuilderConnect/BuilderEsign/BuilderEsign';
import { BuilderConnectInfo } from '../BuilderConnect/BuilderConnectInfo/BuilderConnectInfo';
import DocMasters from '../DocMasters/Documents';
import Packages from '../DocMasters/Packages';
import NewHomeInFile from '../BuilderConnect/InFile/NewHomeInFile';
import SolunoExport from '../Soluno/SolunoExport';
import Summary from '../Summary/Summary'

interface ReactFrameProps {
    reactFrame: string,
}


const ReactFrame = (props: ReactFrameProps) => {
    const livedataRoot: Element = useAppSelector((state) => state.currentNavigation.livedataRootContainer.dataRoot);

     // outside file
     switch (props.reactFrame.toLowerCase()) {
        case 'docmasters':
            return (<DocMasters/>);
        case 'packages':
            return (<Packages/>);
    }

    if(livedataRoot !== null && livedataRoot !== undefined){
        switch (props.reactFrame.toLowerCase()) {
            case 'pips':
                return (<Pips/>);
            case 'ereg':
                return (<EReg/>);
            case 'registration': 
                return (<Registrations/>);
            case 'clientportal':
                return (<ClientPortal/>);
            case 'similiarnames': 
                return (<SimilarNames/>);
            case 'builderdoc':
                return (<BuilderDoc/>);
            case 'builderinfo':
                return (<BuilderConnectInfo/>);
            case 'connectinfile':
                return (<NewHomeInFile/>);
            case 'builderesign':
                return (<BuilderEsign />);
            case 'solunoexport':
                return (<SolunoExport/>);
            case 'summary':
                return (<Summary/>);
            default:
                return (<></>);
        }
    }
    return (<></>);
}

export default ReactFrame;